import React from 'react';

interface ButtonProps {
    // href: string;
    textForButton: string;
    icon?: React.ReactNode;
    className?: string;
    type?: 'submit' | undefined
    value: string
    theme: 'white' | 'blue'
}

export const DefinitelyOurButton: React.FC<ButtonProps> = ({ textForButton, icon, className, type, value, theme }) => {
    if (!textForButton) {
        return null;
    }

    const whiteTheme = `w-fit flex justify-end items-center gap-2.5 py-2 px-5 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300 ${className}`
    const blueTheme = `w-fit flex justify-end items-center gap-2.5 py-2 px-5 rounded-full border border-blue-500 text-white bg-blue-500 hover:bg-white hover:text-blue-500 transition duration-300 ${className}`


    const classNames = theme == 'blue' ? blueTheme : whiteTheme;

    return (
        <button
            value={value}
            type={type}
            className={classNames}
        >
            {textForButton}
            {icon && <span>{icon}</span>}
        </button>
    );
};
